// for debug or style edit
// 1 - pass the mocked payload to  custom tooltip (payload = mockePayload)
// 2 - comment if (active && payload && payload.length)
// 3 - return a tooltip like
// <Tooltip filterNull content={<CustomTooltip />} wrapperStyle={{ visibility: 'visible', width: 'auto%' }}
// position={{ x: 0, y: 210 }} />

import React from 'react'
import { Tooltip } from 'recharts'
import { TooltipWrapper } from '../Charts'

import themeColors from '@layers-frontend/commons/styles/themeColors'
import { surfaces } from '../../../theme'

import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'

import styled from 'styled-components'
import RenderIf from '@layers-frontend/commons/helpers/RenderIf'

// The heading of the chart tooltips (TooltopHeading in Charts.js), with room for the bars' legend square.
const TooltipHeader = styled.div`
  margin: 0px;
  padding: 8px 10px;
  background: ${themeColors.deepblueColor3};
  border: 1px solid ${themeColors.mintBorder};
  white-space: nowrap;
  border-radius: 8px;
  box-shadow: ${surfaces.floatingPanelShadow};
  font-weight: bold;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const TooltipHeaderSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 1px;
`

const TooltipHeaderText = styled.span`
  color: #ffffff;
`

const TooltipListColor = styled.div`
  background: ${props => props.background || 'initial'};
  height: 1rem;
  width: 1rem;
`
const TooltipListItem = styled.div`
  display: flex;
  align-items: baseline;
  & > div:not(:last-child) {
    margin-right: 1rem;
  }
`

const TooltipLabel = styled.div`
  font-weight: 400;
  margin-bottom: 5px;
  color: ${props => props.color || 'inherit'};
`

const TooltipValue = styled.div`
  color: ${themeColors.whiteColor};
  margin-left: auto;
`

const renderTooltipItem = (item, index) => {
  return item ? (
    <TooltipListItem key={index}>
      <TooltipListColor background={item.color} />
      <RenderIf condition={item.label}>
        <TooltipLabel>{item.label}: </TooltipLabel>
      </RenderIf>
      <TooltipValue>{item.value}</TooltipValue>
    </TooltipListItem>
  ) : null
}

function createSeasonEvolutionTooltip({ getTitle, getData, hasBars = false }) {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const title = getTitle(payload)
      const tooltipData = getData(payload)

      if (isEmpty(tooltipData)) return null

      return (
        <div>
          {title ? (
            <TooltipHeader>
              {hasBars && <TooltipHeaderSquare />}
              <TooltipHeaderText>{title}</TooltipHeaderText>
            </TooltipHeader>
          ) : null}
          <TooltipWrapper>{map(tooltipData, renderTooltipItem)}</TooltipWrapper>
        </div>
      )
    }

    return null
  }

  return <Tooltip filterNull content={<CustomTooltip />} wrapperStyle={{ zIndex: 1 }} isAnimationActive={false} />
}

export default createSeasonEvolutionTooltip
